module.exports = __webpack_public_path__ + "static/media/light_bulb.e39da9a3.svg";